import { defineSlotRecipe as r } from "@pandacss/dev";
import { anatomy as o } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/file-upload/dist/index.mjs";
const l = r({
  className: "multi-file-upload",
  slots: o.keys(),
  variants: {
    error: {
      true: {
        dropzone: {
          borderColor: "border-error",
          backgroundColor: "bg-error-primary",
          _hover: {
            backgroundColor: "bg-error-primary!"
          }
        }
      }
    }
  }
});
export {
  l as multiFileUpload
};
